import { useDebounce } from '@uidotdev/usehooks';
import { useState } from 'react';

import { Option } from '../../../../components/ui/autocomplete/auto-complete-input';
import { ResetFilterButton } from '../../../../components/ui/button';
import {
    AutoCompleteFilter,
    TextSearchFilter,
} from '../../../../components/ui/search-filter';
import { useGetBrandsQuery } from '../../../../features/slice/products/brand/brand-api-slice';
import { useGetGenericsQuery } from '../../../../features/slice/products/generic/generic-api-slice';
import { useUrlFilter } from '../../../../hooks';

export const ProductListFilters = () => {
    const [brandSearchText, setBrandSearchText] = useState('');
    const debouncedBrandSearchText = useDebounce(brandSearchText, 300);

    const [genericSearchText, setGenericSearchText] = useState('');
    const debouncedGenericSearchText = useDebounce(genericSearchText, 300);

    const { searchText, setSearchText, setSearchFilter } = useUrlFilter();

    // const brandFilterId = getSearchFilter('brand_id');

    const { data: brandsData } = useGetBrandsQuery({
        search: debouncedBrandSearchText,
    });

    const { data: genericsData } = useGetGenericsQuery({
        search: debouncedGenericSearchText,
    });

    const handleBrandChange = (value: Option) => {
        if (!value) {
            setSearchFilter('brand_id', '');
            return;
        }
        setSearchFilter('brand_id', value.value);
    };

    const brandOptions =
        brandsData?.data.map((brand: any) => ({
            label: brand.name,
            value: brand.id,
        })) || [];

    const genericOptions =
        genericsData?.data.map((generic: any) => ({
            label: generic.name,
            value: generic.id,
        })) || [];

    return (
        <div className="flex flex-wrap items-start justify-start gap-2">
            <TextSearchFilter
                value={searchText}
                onChangeSearch={(e) => setSearchText(e.target.value)}
                placeholder="product"
            />

            <AutoCompleteFilter
                onInputChange={setBrandSearchText}
                options={brandOptions}
                onValueChange={handleBrandChange}
                placeholder="Select brand"
            />

            <AutoCompleteFilter
                onInputChange={setGenericSearchText}
                options={genericOptions}
                placeholder="Select generic"
                onValueChange={(value: Option) => {
                    if (!value) {
                        setSearchFilter('generic_id', '');
                        return;
                    }
                    setSearchFilter('generic_id', value.value);
                }}
            />

            <ResetFilterButton />
        </div>
    );
};

ProductListFilters.displayName = 'ProductListFilters';
